import { sendCartDrawerOpenRequestEvent } from '../core/notifications/cart-drawer-open-request';
const FLOATING_CART_BUTTON_SELECTOR = '.js-floating-cart-button';
const PRODUCTION_HOST = 'lakepajamas.com';
const isLocalDevelopmentMode = ()=>{
    return window.location.hostname !== PRODUCTION_HOST && !window.location.hostname.endsWith(`.${PRODUCTION_HOST}`);
};
export const init = async ()=>{
    const button = document.querySelector(FLOATING_CART_BUTTON_SELECTOR);
    if (!(button instanceof HTMLButtonElement)) {
        return;
    }
    if (!isLocalDevelopmentMode()) {
        button.remove();
        return;
    }
    button.addEventListener('click', ()=>{
        sendCartDrawerOpenRequestEvent();
    });
};
